/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const AUDIT_LOG_COLUMNS = [
  {
    id: "created_at",
    label: "When",
    accessorKey: "created_at",
    sortable: true,
    filterable: true,
    filterType: "text",
    className: "whitespace-nowrap tabular text-xs",
  },
  {
    id: "actor_name",
    label: "User",
    accessorKey: "actor_name",
    sortable: true,
    filterable: true,
    filterType: "text",
    className: "min-w-[120px]",
  },
  {
    id: "actor_email",
    label: "Email",
    accessorKey: "actor_email",
    filterable: true,
    filterType: "text",
    hideInTable: true,
  },
  {
    id: "action",
    label: "Action",
    accessorKey: "action",
    sortable: true,
    filterable: true,
    filterType: "select",
    filterOptions: [
      { value: "CREATE", label: "Create" },
      { value: "UPDATE", label: "Update" },
      { value: "DELETE", label: "Delete" },
      { value: "LOGIN", label: "Login" },
      { value: "ADMIN", label: "Admin" },
      { value: "OTHER", label: "Other" },
    ],
    className: "whitespace-nowrap",
  },
  {
    id: "category",
    label: "Category",
    accessorKey: "category",
    sortable: true,
    filterable: true,
    filterType: "select",
    filterOptions: [
      { value: "api", label: "API" },
      { value: "auth", label: "Auth" },
      { value: "admin", label: "Admin" },
    ],
    className: "whitespace-nowrap capitalize",
  },
  {
    id: "entity_type",
    label: "Entity",
    accessorKey: "entity_type",
    sortable: true,
    filterable: true,
    filterType: "text",
    className: "whitespace-nowrap",
  },
  {
    id: "summary",
    label: "Summary",
    accessorKey: "summary",
    filterable: true,
    filterType: "text",
    className: "min-w-[200px] max-w-[420px] text-xs",
  },
  {
    id: "change_count",
    label: "Changes",
    accessorKey: "change_count",
    className: "whitespace-nowrap text-xs",
  },
  {
    id: "status_code",
    label: "Status",
    accessorKey: "status_code",
    sortable: true,
    className: "whitespace-nowrap tabular text-xs",
  },
  {
    id: "path",
    label: "Path",
    accessorKey: "path",
    filterable: true,
    filterType: "text",
    hideInTable: true,
  },
  {
    id: "date_from",
    label: "From date",
    filterable: true,
    filterType: "date",
    hideInTable: true,
  },
  {
    id: "date_to",
    label: "To date",
    filterable: true,
    filterType: "date",
    hideInTable: true,
  },
];

export function formatAuditCell(col, row) {
  switch (col.id) {
    case "created_at":
      return row.created_at?.replace("T", " ").slice(0, 19) || "—";
    case "actor_name":
      return row.actor_name || "—";
    case "entity_type":
      if (!row.entity_type && !row.entity_id) return "—";
      return `${row.entity_type || "—"}${row.entity_id ? ` #${row.entity_id}` : ""}`;
    case "status_code": {
      const code = row.status_code;
      if (!code) return "—";
      return String(code);
    }
    default:
      return row[col.accessorKey || col.id] ?? "—";
  }
}

export function auditStatusTone(code) {
  if (!code) return "";
  if (code >= 400) return "text-red-700";
  if (code >= 300) return "text-amber-800";
  return "text-emerald-800";
}
